/** Проверяем deep link, прежде чем предлагать открыть внешний ответ. */
export function getTelegramBotLink(data: unknown): string | null {
  const item = data && typeof data === 'object' ? data as Record<string, unknown> : null;
  const candidate = item?.url;
  if (typeof candidate !== 'string') return null;
  try {
    const url = new URL(candidate);
    return url.protocol === 'https:' && url.hostname === 't.me' && !url.username && !url.password && !url.port && url.pathname.length > 1 ? url.href : null;
  } catch { return null; }
}
